import { useCallback, useEffect, useState } from 'react'
import HomeUnifiedHero from './HomeUnifiedHero'
import { getRegistrationHeroState } from '../../utils/registrationHeroState'
import { getRegistrationCountdownDisplay } from '../../utils/registrationCountdown'

// 종료 timestamp와 매 tick의 실제 현재 시각으로 다시 계산한다. interval 횟수로
// 감소시키지 않으므로 background 복귀와 timer drift에도 표시가 늦어지지 않는다.
function LiveCountdown({ targetAt, onModeChange }) {
  const [display, setDisplay] = useState(() => getRegistrationCountdownDisplay(targetAt))

  useEffect(() => {
    const update = () => setDisplay(getRegistrationCountdownDisplay(targetAt))
    update()
    const id = setInterval(() => {
      update()
    }, 1000)
    return () => clearInterval(id)
  }, [targetAt])

  useEffect(() => {
    onModeChange?.(display.mode)
  }, [display.mode, onModeChange])

  return (
    <span className={`registration-hero__countdown registration-hero__countdown--${display.mode}`}>
      {display.text}
    </span>
  )
}

// 9월 1일 개강 전까지 홈 Hero의 기본값. 레이아웃(HomeUnifiedHero)은 그대로
// 재사용하고, 학년별 수강신청 일정 상태만 registration variant로 채운다.
export default function RegistrationHeroCard({ isDark, profile, now, onClick, previewState = null }) {
  // previewState는 관리자 화면에서만 주입하는 표시용 fixture다. 실제 홈은
  // 기존처럼 현재 시각과 학년으로만 상태를 계산한다.
  const state = previewState ?? getRegistrationHeroState({ now, grade: profile?.grade })
  const initialCountdownMode = state.big.mode === 'countdown'
    ? getRegistrationCountdownDisplay(state.big.targetAt, now).mode
    : null
  const [countdownMode, setCountdownMode] = useState(initialCountdownMode)
  const handleModeChange = useCallback(mode => setCountdownMode(mode), [])
  useEffect(() => {
    setCountdownMode(initialCountdownMode)
  }, [initialCountdownMode, state.big.targetAt])
  const big = state.big.mode === 'countdown'
    ? <LiveCountdown targetAt={state.big.targetAt} onModeChange={handleModeChange} />
    : state.big.value
  const registrationLabel = countdownMode === 'seconds'
    ? '예비수강신청 마감까지'
    : countdownMode === 'ended'
      ? '예비수강신청 종료'
      : state.label

  return (
    <HomeUnifiedHero
      isDark={isDark}
      variant="registration"
      motionMode="registration"
      urgent={state.big.mode === 'countdown'}
      metaLine={state.metaLine}
      registrationLabel={registrationLabel}
      registrationBig={big}
      registrationCaption={state.caption}
      subLine={state.prompt}
      ctaLabel="수강신청 허브 가기"
      onClick={onClick}
    />
  )
}
